import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { ObjectListBuilderComponentModule } from '@adaptiva/widgets/object-list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { CveMappingPropertiesComponent } from './cve-mapping-properties.component';
import { AdaBindMethodPipe } from '@adaptiva/core/common';

const PIPES = [
	AdaBindMethodPipe,
	DisplayAuthoringPropertyPipe,
	InheritPipe,
	IsRequiredPropertyPipe
];

const WIDGETS = [
	AuthoringPropertyLabelComponentModule,
	ButtonComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	LabelComponentModule,
	ObjectListBuilderComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [CveMappingPropertiesComponent],
	exports: [CveMappingPropertiesComponent]
})
export class CveMappingPropertiesComponentModule {

}
